// src/components/PrivateRoute.js
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import tokenExpirationHandler from '../utils/tokenExpirationHandler';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  // Verificar si el token es válido
  const isTokenValid = tokenExpirationHandler.isTokenValid();
  
  // Si no hay token o el token es inválido, redirigir al login
  if (!token || !isTokenValid) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default PrivateRoute;
